export default {
  namespaced: true,

  state: {
    firstName: '',
    lastName: '',
    email: '',
    _id: '',
    language: '',
    phone: ''
  },

  mutations: {
    set: function (state, user) {
      state.firstName = user.firstName
      state.lastName = user.lastName
      state.email = user.email
      state._id = user.uuid
      state.language = user.language
      state.phone = user.phone
    },
    reset: function (state) {
      state = {
        firstName: '',
        lastName: '',
        email: '',
        _id: '',
        language: '',
        phone: ''
      }
    }
  }
}
